module.exports = __webpack_public_path__ + "img/Edit-icon.7f8aa38b.svg";